import React from 'react';
import PropTypes from 'prop-types';

import { fromJS } from 'immutable';

import BlockAddresses from './BlockAddresses/BlockAddresses';
import BlockContracts from './BlockContracts/BlockContracts';
import BlockContacts from './BlockContacts/BlockContacts';
import BlockLegalInfos from './BlockInfos/BlockLegalInfos';
import BlockBankAccounts from './BlockBankAccounts/BlockBankAccounts';
import BlockRelations from './BlockRelations/BlockRelations';
import BlockPaymentCard from './BlockPaymentCard/BlockPaymentCard.js'

// birth_date, email, first_name, gender, name, code, birth_name, birth_order
const LegalPerson = ({
  party,
  strings,
  i18n,
  updatePartyCompany,
  updatePartyId,
  updatePartyAddresses,
  updatePartyContacts,
  updatePartyRelations,
  updatePartyBankAccounts,
  changePaymentCard
}) => (
  <div className="physical-party">
    <BlockLegalInfos
      party={party}
      strings={strings}
      i18n={i18n}
      updatePartyCompany={updatePartyCompany}
      id={party.id}
    />
    <BlockAddresses
      party={party}
      strings={strings}
      i18n={i18n}
      id={party.id}
      updatePartyAddresses={updatePartyAddresses}
    />
    <BlockContacts
      party={party}
      strings={strings}
      i18n={i18n}
      id={party.id}
      updatePartyContacts={updatePartyContacts}
    />
    <BlockBankAccounts
      party={party}
      strings={strings}
      i18n={i18n}
      id={party.id}
      updatePartyBankAccounts={updatePartyBankAccounts}
    />
    <BlockRelations
      party={party}
      strings={strings}
      i18n={i18n}
      updatePartyId={updatePartyId}
      id={party.id}
      updatePartyRelations={updatePartyRelations}
    />
    <BlockContracts
      party={party}
      strings={strings}
      i18n={i18n}
      id={party.id}
    />
    {/* <BlockPaymentCard
      party={party}
      strings={strings}
      i18n={i18n}
      id={party.id}
      changePaymentCard={changePaymentCard}
    /> */}
  </div>
);

LegalPerson.propTypes = {
  strings: PropTypes.objectOf(PropTypes.string),
  // eslint-disable-next-line react/forbid-prop-types
  party: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  i18n: PropTypes.object,
  updatePartyCompany: PropTypes.func.isRequired,
  updatePartyId: PropTypes.func.isRequired,
  updatePartyAddresses: PropTypes.func.isRequired,
  updatePartyContacts: PropTypes.func.isRequired,
  updatePartyBankAccounts: PropTypes.func.isRequired,
  updatePartyRelations: PropTypes.func.isRequired,
  changePaymentCard: PropTypes.func
};

LegalPerson.defaultProps = {
  party: {},
  strings: {},
  i18n: fromJS({})
};

export default LegalPerson;
